/**
 * Enum for Dashboard IDs.
 */
export enum DashboardIds {
  homePage = 16,
  optimizationReport = 18
}
